"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialSuiteValuesFromUserData = exports.convertCustom9ToPaymentGuestValues = exports.ReactGAFinalizarReserva = exports.sendToConvertionGoogleAnalytics = exports.pixGrossAmount = void 0;
const moment_1 = __importDefault(require("moment"));
const react_ga_1 = __importDefault(require("react-ga"));
const constants_1 = require("../../../assets/constants/constants");
const helpers_1 = require("../../../utils/helpers");
// TODO: [XP360-894] Refatorar a função que realiza o calculo do valor bruto para ser chamado no pixel.
const pixGrossAmount = (checkout) => {
    let sum = 0;
    sum +=
        (checkout.extraAmount || 0) +
            checkout.items.reduce((soma, value) => soma + value.amount * value.quantity, 0);
    sum += checkout.discountAmount > 0 ? checkout.discountAmount * -1 : checkout.discountAmount;
    return sum;
};
exports.pixGrossAmount = pixGrossAmount;
const sendToConvertionGoogleAnalytics = (total, bookId, bookingName) => {
    react_ga_1.default.plugin.require('ecommerce', { debug: true });
    react_ga_1.default.plugin.execute('ecommerce', 'purchase', {
        id: bookId,
        name: bookingName,
        value: total,
        currency: 'BRL',
    });
    react_ga_1.default.plugin.execute('ecommerce', 'send', null);
    react_ga_1.default.plugin.execute('ecommerce', 'clear', null);
};
exports.sendToConvertionGoogleAnalytics = sendToConvertionGoogleAnalytics;
const ReactGAFinalizarReserva = () => {
    react_ga_1.default.event({ category: 'Button', action: 'Click button "finalizar reserva"' });
};
exports.ReactGAFinalizarReserva = ReactGAFinalizarReserva;
// Converte os dados vindos do custom9 para o formato aplicavel ao formulário
const convertCustom9ToPaymentGuestValues = (formValues, custom9, guestsQty, custom5) => {
    var _a, _b, _c, _d, _e;
    const birthDate = custom9.birthday
        ? (0, moment_1.default)(custom9.birthday, constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL).format(constants_1.DEFAULT_FORMAT_DATE_PT_BR)
        : '';
    const ddiRequired = custom9.ddi;
    const phoneRequired = custom9.phone.replace(ddiRequired, '');
    const [addressName, addressNumber, addressComplement, addressDistrict] = custom9.address.fullAddress.split('\n');
    const brandColor = (((_a = custom9.vehicles) === null || _a === void 0 ? void 0 : _a[0].model.includes('-'))
        ? (_b = custom9.vehicles) === null || _b === void 0 ? void 0 : _b[0].model.split('-')
        : (_c = custom9.vehicles) === null || _c === void 0 ? void 0 : _c[0].model.split(' ')) || [];
    const vehiclePlate = (_d = custom9.vehicles) === null || _d === void 0 ? void 0 : _d[0].plate;
    const typePlate = ((_e = vehiclePlate === null || vehiclePlate === void 0 ? void 0 : vehiclePlate.trim()) === null || _e === void 0 ? void 0 : _e.length) === 7 ? 'mercosul' : 'default';
    const [checkInTimeAux, checkOutTimeAux] = custom5 ? custom5.split('|') : '';
    const checkInTime = checkInTimeAux.replace('Check-in: ', '');
    const checkOutTime = checkOutTimeAux.replace('Check-out: ', '');
    let guestsList = [...custom9.guests];
    if (custom9.visitors) {
        guestsList = [...guestsList, ...custom9.visitors];
    }
    const guestDataFields = guestsList.map((guest, index) => {
        const birtDayGuest = (0, moment_1.default)(guest.birthday, constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL);
        const ddiGuest = guest.ddi ? guest.ddi : '55';
        const phoneGuest = guest.phone ? guest.phone.replace(ddiGuest, '') : '';
        return {
            id: index,
            fullname: guest.name ? guest.name : '',
            documentTypeGuest: guest.docType ? guest.docType : 'CPF',
            documentGuest: guest.doc ? guest.doc : '',
            birthday: birtDayGuest.isValid() ? birtDayGuest.format(constants_1.DEFAULT_FORMAT_DATE_PT_BR) : '',
            email: guest.email ? guest.email : '',
            ddi: ddiGuest,
            phone: phoneGuest,
        };
    });
    const guestsEmpty = Array(Number(guestsQty) - guestsList.length - 1)
        .fill(0)
        .map((id, index) => ({
        id: index + custom9.guests.length,
        fullname: '',
        documentTypeGuest: 'CPF',
        documentGuest: '',
        birthday: '',
        email: '',
        ddi: '55',
        phone: '',
    }));
    if (guestsEmpty.length > 0)
        guestDataFields.push(...guestsEmpty);
    const formSuites = (formValues === null || formValues === void 0 ? void 0 : formValues.suites[0]) || {};
    let vehicleBrand = '';
    if ((brandColor === null || brandColor === void 0 ? void 0 : brandColor.length) > 2) {
        for (let i = 0; i < brandColor.length - 1; i++) {
            vehicleBrand = `${vehicleBrand}${i ? ' ' : ''}${brandColor === null || brandColor === void 0 ? void 0 : brandColor[i]}`;
        }
    }
    else {
        vehicleBrand = `${(brandColor === null || brandColor === void 0 ? void 0 : brandColor[0]) || ''}`;
    }
    const suite = Object.assign(Object.assign({}, formSuites), { id: '1', bookingReason: undefined, refundProtect: false, refundValue: 0, fullnameRequired: custom9.name, birthdayRequired: birthDate, ddiRequired,
        phoneRequired, documentTypeGuestRequired: custom9.docType ? custom9.docType : 'CPF', documentGuestRequired: custom9.doc, addressCep: custom9.address.zip, addressName: (0, helpers_1.myTrim)(addressName), addressNumber: (0, helpers_1.myTrim)(addressNumber), addressComplement: (0, helpers_1.myTrim)(addressComplement), addressDistrict: (0, helpers_1.myTrim)(addressDistrict), addressCity: custom9.address.city, addressState: custom9.address.state, country: custom9.address.country, emailRequired: custom9.address.email || custom9.email, guests: guestDataFields, vehicleBrand, vehicleColor: (brandColor === null || brandColor === void 0 ? void 0 : brandColor[brandColor.length - 1]) || '', vehiclePlate: vehiclePlate ? vehiclePlate.trim() : '', vechiclePlateType: typePlate, checkInTime,
        checkOutTime, hostingWork: custom9.hostingWork || false, hostingPurchases: custom9.hostingPurchases || false, hostingTourism: custom9.hostingTourism || false, hostingPrivacy: custom9.hostingPrivacy || false });
    return Object.assign(Object.assign({}, formValues), { suites: [suite] });
};
exports.convertCustom9ToPaymentGuestValues = convertCustom9ToPaymentGuestValues;
const getInitialSuiteValuesFromUserData = (formValues, userData) => {
    // Como não tem dados salvos direto no formulário, busca os dados do cadastro para autopreenchimento
    return formValues.suites.map((v) => {
        var _a;
        const birthDate = userData.birthDate ? (0, moment_1.default)(userData.birthDate, 'yyyy-MM-DD').format('DD/MM/yyyy') : '';
        // decompõe o telefone do BD em DDI e Telefone
        let ddiRequired;
        let phoneRequired;
        const telephone = (userData === null || userData === void 0 ? void 0 : userData.telephone) ? (_a = userData === null || userData === void 0 ? void 0 : userData.telephone) === null || _a === void 0 ? void 0 : _a.split('#') : [];
        // verifica se está no formato com DDI
        if (telephone.length === 2) {
            [ddiRequired, phoneRequired] = telephone;
        }
        else {
            // Não estando no padrão correto, atribui o DDI brasileiro por padrão e põe os números no campo de telefone
            ddiRequired = '55';
            phoneRequired = (userData === null || userData === void 0 ? void 0 : userData.telephone) ? userData === null || userData === void 0 ? void 0 : userData.telephone.replace(/\D/g, '') : '';
        }
        return Object.assign(Object.assign({}, v), { fullnameRequired: `${userData.firstName} ${userData.lastName}`, birthdayRequired: birthDate, ddiRequired,
            phoneRequired });
    });
};
exports.getInitialSuiteValuesFromUserData = getInitialSuiteValuesFromUserData;
